import { FC, useContext } from 'react';
import { ProfileSetupContext } from './ProfileSetupContext';

const ProfileSetupViewBody: FC = () => {
  const { currentStep } = useContext(ProfileSetupContext);
  const { Body } = currentStep;

  return <Body />;
};

export default ProfileSetupViewBody;
